module.exports = __webpack_public_path__ + "img/er.d7790c41.svg";